import React, { useState } from 'react';
import {
  Paper,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';

interface TermsAndConditionsProps {
  onAccept: () => void;
}

const placeholderText = `
To proceed, please upload your KYB (Know Your Business) documents for verification. Ensure that all required documents are clear and valid.

By submitting your KYB documents, you agree to our terms of service and privacy policy. We take compliance seriously and follow strict guidelines to protect your business data.

Click the button below to begin uploading your documents.
`;


const TermsAndConditions: React.FC<TermsAndConditionsProps> = ({ onAccept }) => {
  const [checked, setChecked] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor={theme.palette.background.default}
      p={isMobile ? 1 : 3}
    >
      <Paper elevation={3} sx={{ maxWidth: 500, width: '100%', p: isMobile ? 2 : 4 }}>
        <Typography variant="h5" fontWeight={600} gutterBottom align="center">
          Terms and Conditions
        </Typography>
        <Box
          sx={{
            border: '1px solid',
            borderColor: theme.palette.divider,
            borderRadius: 2,
            p: 2,
            mb: 3,
            maxHeight: 250,
            overflowY: 'auto',
            background: theme.palette.background.paper,
          }}
        >
          <Typography variant="body2" color="text.secondary" style={{ whiteSpace: 'pre-line' }}>
            {placeholderText}
          </Typography>
        </Box>
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={e => setChecked(e.target.checked)}
              color="primary"
            />
          }
          label="I agree to the Terms and Conditions"
          sx={{ mb: 2 }}
        />
        <Button
          variant="contained"
          color="primary"
          fullWidth
          disabled={!checked}
          onClick={onAccept}
          sx={{ mt: 1 }}
        >
          Continue to KYB Form
        </Button>
      </Paper>
    </Box>
  );
};

export default TermsAndConditions; 